import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	height: 100vh;
	flex-direction: column;
`;

export default Container;
